// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__ZzOuS","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2sWXh","obliqueLine":"membershipbadge_obliqueLine__3FzsG"};